module.exports = __webpack_public_path__ + "static/media/4.69633899.webp";